function getApiUrl() {
  return `${process.env.BACKEND_API_URL}api`;
}

function getApiPath(user) {
  const userData = getUserData(user)
  return `${getApiUrl()}/${userData.role}/${userData.id}`;
}

function getApiV2Url() {
  return `${process.env.BACKEND_API_URL}api/v2`;
}

function getAdminUrl() {
  return `${process.env.BACKEND_API_URL}`;
}

function getAdminPath(user, prefix = null) {
  const userData = getUserData(user)
  const pref = prefix ? prefix + '/' : ''
  return `${getAdminUrl()}${pref}${userData.role}/${userData.id}`;
}

function getUserData(user) {
  let role = `${user.data.selectedRole.role}s`;
  let id = user.data.selectedRole.id;
  if (user.data.selectedRole.isSuperadmin) {
    role = 'superadmin';
    id = user.data.id;
  }
  return {
    id: id,
    role: role
  }
}

export {getApiUrl, getApiPath, getAdminPath, getApiV2Url};



// WEBPACK FOOTER //
// ./src/store/store-helpers.js